<template>
  <div class="mod-success">
    <a-icon theme="filled" type="check-circle" />
    <p>恭喜您，{{ title }}成功，请妥善保管个人信息！</p>
    <div class="action">
      <a-button size="large" type="primary" @click="onBack">返回</a-button>
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/utils/util'

export default {
  props: {
    title: String
  },
  methods: {
    onBack () {
      if (isMobile()) {
        window.__MICRO_ROOT__?.eventBus?.emit('AuthenticateSetting::Success', null)
      } else {
        // 实名认证成功，修正数据
        const userInfo = this.$ls.get('USER_CENTER_INFO')
        userInfo.authStatus = 4
        this.$ls.set('USER_CENTER_INFO', userInfo)

        const redirectUrl = window.sessionStorage.getItem('redirect')

        if (redirectUrl) {
          window.location.replace(redirectUrl)
          window.sessionStorage.removeItem('redirect')
        } else {
          this.$router.replace('/account')
        }
      }
    }
  }
}
</script>
